import React from "react";

const ModalContext = React.createContext();

function useModal() {
  const context = React.useContext(ModalContext);
  if ( ! context ) {
    throw new Error(`useModal must be used within an ModalContext`);
  }

  const [Modal, setModal] = context;

  const toggleModalVisibility = () => {
    setModal({...Modal, visible: (Modal.visible ? false : true) })
  };

  const showModal = () => {
    setModal({...Modal, visible: true })
  };

  const hideModal = () => {
    setModal({...Modal, visible: false })
  };

  return {
    modalVisibility: Modal?.visible || false,
    toggleModalVisibility,
    showModal,
    hideModal
  }
}

function ModalProvider(props) {
  const [Modal, setModal] = React.useState({ visible: false});
  const value = React.useMemo(() => [Modal, setModal], [Modal]);
  return <ModalContext.Provider value={value} {...props} />;
}

export {
  ModalProvider,
  useModal
}